import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class SampleMixin extends Vue {
  /**
   * 当前用户详情
   */
  private get _userDetail() {
    return this.$store.state["user-detail"].userDetail;
  }

  /**
   * 当前选中的样本的详情
   */
  public get currentSampleId(): string {
    return this.$route.params.sample_id;
  }

  /**
   * 当前选中的样本对象
   */
  public get currentSampleObj(): any {
    const { currentSampleId, _userDetail } = this;
    if (!_userDetail || !currentSampleId) return null;
    return (_userDetail?.samples || []).find(
      (s: any) => s.id === currentSampleId
    );
  }
}
